exports.components = {
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-article-tsx": () => import("./../../../src/templates/article.tsx" /* webpackChunkName: "component---src-templates-article-tsx" */),
  "component---src-templates-plain-page-tsx": () => import("./../../../src/templates/plainPage.tsx" /* webpackChunkName: "component---src-templates-plain-page-tsx" */),
  "component---src-templates-press-release-tsx": () => import("./../../../src/templates/pressRelease.tsx" /* webpackChunkName: "component---src-templates-press-release-tsx" */)
}

